SingleProduct
	.constant( 'API_URL', ( function(){
		return {
			CART: API_URL + '/cart',
			RELATED_PRODUCTS: API_URL + '/product/related'
		}
	})())
	.constant( 'DATA', ( function() {
		var attrSizeUnit;
		var variaions = VARIATIONS.map(function( variation ){
			attrSizeUnit = variation.attributes.hasOwnProperty('attribute_pa_liter') ? 'attribute_pa_liter' :  'attribute_pa_kilogram';
			variation.attributes[ attrSizeUnit ] = variation.attributes[ attrSizeUnit ].replace('-', '.');
			return variation
		});
		return {
			PRODUCT_ID: PRODUCT_ID,
			ATTRIBUTES: ATTRIBUTES,
			HUE: HUE === 'false' ? false : HUE,
			VARIATIONS: variaions,
			ATTR_SIZE_UNIT: attrSizeUnit.replace('attribute_', ''),
			FINISHINGS: FINISHINGS,
			DEF_COLOR: DEF_COLOR,
		}
	})())

